import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrderWindow } from '../../../models/order-window.model';
import { OrderService } from '../../../services/order.service';
import { isEmptyArray } from '../../../shared/utils';

@Component({
  selector: 'budget-details-modal',
  templateUrl: './buying-windows-details-modal.component.html',
  styleUrls: ['./buying-windows-details-modal.component.scss'],
  standalone: false,
})
export class BuyingWindowsDetailsModalComponent implements OnInit {
  orderWindows: OrderWindow[] = [];

  orderWindowByYears: { [key: number]: OrderWindow[] } = {};
  selectedYear: number;
  years: number[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    this.orderWindows = this.orderService.orderWindowsForCalendar;
    this.splitOrderWindowsByYears();
  }

  close() {
    this.activeModal.close();
  }

  private splitOrderWindowsByYears() {
    this.orderWindowByYears = {};

    this.orderWindows.forEach((ow) => {
      if (!ow.market_year) {
        return;
      }

      const year = ow.market_year;

      if (!this.orderWindowByYears[year]) {
        this.orderWindowByYears[year] = [];
      }

      this.orderWindowByYears[year].push(ow);
    });

    if (Object.keys(this.orderWindowByYears).length > 0) {
      this.years = Object.keys(this.orderWindowByYears)
        .map((year) => Number(year))
        .sort((a, b) => b - a);

      const currentYear = this.currentlyViewedYear();
      this.selectedYear =
        currentYear && this.years.includes(currentYear)
          ? currentYear
          : this.years[0];

      // for each year sort order windows by start date
      for (const year of this.years) {
        this.orderWindowByYears[year] = (
          this.orderWindowByYears[year] || []
        ).sort((ow1, ow2) => (ow1.start_at.isBefore(ow2.start_at) ? 1 : -1));
      }
    }
  }

  // Mirrors the URL-based resolution used by the header callout: the window
  // being viewed is the one whose id appears in the current route. Falls back
  // to the active order window when the URL is not a buying-window URL.
  private currentlyViewedYear(): number | null {
    // case 1: no active window is selected find closest of next one to the current date
    const now = new Date();
    const sortedByMarketYear = [...this.orderWindows].sort(
      (ow1, ow2) => ow2.market_year - ow1.market_year
    );

    const activeWindows = sortedByMarketYear.filter((bw) => bw.active);
    if (!isEmptyArray(activeWindows)) {
      const foundYear = activeWindows[0].market_year;
      if (foundYear) {
        return foundYear;
      }
    }

    // case 2: select a tab of upcoming window if there is no active window
    const upComingWindows = sortedByMarketYear.filter((bw) => bw.upcoming);
    if (!isEmptyArray(upComingWindows)) {
      const foundYear = upComingWindows[0].market_year;
      if (foundYear) {
        return foundYear;
      }
    }

    return this.years[0] || now.getFullYear();

    // const match = this.router.url.match(/\/buying-window\/(\d+)(\b|\/)/);
    // if (match) {
    //   const id = +match[1];
    //   const w = this.orderService.orderWindows.find((ow) => ow.id === id);
    //   if (w?.market_year) {
    //     return w.market_year;
    //   }
    // }
    // return this.orderService.activeOrderWindow?.market_year ?? null;
  }

  onYearChange(year: number) {
    this.selectedYear = year;
  }

  get selectedBuyingWindows() {
    return this.orderWindowByYears[this.selectedYear];
  }

  trackByOrderWindow(index: number, orderWindow: OrderWindow): number {
    return orderWindow.id;
  }
}
